<template>
  <div>
    <div style="border: 1px solid #ccc; margin-top: 10px">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
      />
      <Editor
        style="height: 500px; overflow-y: hidden"
        :defaultConfig="editorConfig"
        v-model="html"
        @onChange="onChange"
        @onCreated="onCreated"
      />
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import Vue from 'vue';
export default {
  name: 'wangedit',
  components: { Editor, Toolbar },
  data () {
    return {
      editor: null,
      html: '<p><br></p>',
      toolbarConfig: {
        excludeKeys: ['fullScreen', 'uploadVideo']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            server: process.env.VUE_APP_BASE_API + '/common/upload',
            withCredentials: true,
            fieldName: 'file',
            maxFileSize: 20 * 1024 * 1024,
            meta: {
              type: 4
            },
            timeout: 25 * 1000,
            customInsert (res, insertFn) {
              insertFn(res.data.fileUrl);
            },
            onBeforeUpload (file) {
              return file;
            },
            onProgress (progress) {
              console.log('progress', progress);
            },
            onSuccess (file, res) {
              console.log(`${file.name} 上传成功`, res);
            },
            onFailed (file, res) {
              console.log(`${file.name} 上传失败`, res);
            },
            onError (file, err, res) {
              console.log(`${file.name} 上传出错`, err, res);
            }
          }
        }
      }
    };
  },
  methods: {
    onCreated (editor) {
      this.editor = Object.seal(editor);
      console.log('onCreated', this.editor);
    },
    onChange (editor) {
      console.log('onChange', editor.getHtml());
    },
    getEditorText () {
      const editor = this.editor;
      if (editor == null) return;

      console.log(editor.getText());
    },
    printEditorHtml () {
      const editor = this.editor;
      if (editor == null) return;

      console.log(editor.getHtml());
    }
  },
  mounted () {
  },
  beforeDestroy () {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy();
  }
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
::v-deep em{
  font-style: italic;
}
::v-deep .w-e-modal button{
  line-height:25px;
}
::v-deep .w-e-modal{
  bottom: 10px !important;
  top: 10px !important;
}
</style>
